import { Button, Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

interface Props {
  handleClose: any
  handleDelete: any
  loadingBtn: boolean
  title: string
}

function DeletePopup({ handleClose, handleDelete, loadingBtn, title }: Props) {
  const { t } = useTranslation()
  return (
    <div className="newFont prevent-select">
      <Modal.Header className="bg-white">
        <p className="post-card-title">
          {t('delete')} {title} {t('confirmation')}
        </p>
        <Button variant="inherit" className="close me-2" onClick={handleClose}>
          <i className="fa-regular fa-x icon-size" />
        </Button>
      </Modal.Header>
      <Modal.Body className="post-card-padding card-font-size">
        <p>
          {t('delete_confirm_txt1')} {title}, {t('delete_confirm_txt2')} {title}{' '}
          {t('permanently')}.
        </p>
        <p>
          {t('delete_confirm_txt3')} {title}, {t('delete_confirm_txt4')}
        </p>
        <div className="auction-create-buttons">
          <button
            onClick={handleClose}
            className="text-white payment-button-cancel"
          >
            {t('close')}
          </button>
          <button
            onClick={handleDelete}
            className="text-white payment-button-tryagain"
            disabled={loadingBtn}
          >
            {loadingBtn ? (
              <Spinner animation="border" variant="light" />
            ) : (
              t('delete')
            )}
          </button>
        </div>
      </Modal.Body>
    </div>
  )
}
export default DeletePopup
